module.exports = __webpack_public_path__ + "static/img/03hehe.4dc2f9c0.gif";